module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 _.each(participants,function(el) { ;
__p += '\n	<div class="participant-row">\n		<div class="participant-info">\n			<div>' +
((__t = ( el.title )) == null ? '' : __t) +
' - ' +
((__t = ( el.name )) == null ? '' : __t) +
'</div>\n		</div>\n		<div class="participant-photo">\n			<img style="border-radius: 15px;" width=32 height=32 src="' +
((__t = ( el.photo_url )) == null ? '' : __t) +
'">\n		</div>\n	</div>\n';
 }) ;
__p += '\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/widget-participant-tooltip.html
// module id = 149
// module chunks = 0